import { render, staticRenderFns } from "./videoRoom.vue?vue&type=template&id=0da39dee&scoped=true"
import script from "./videoRoom.vue?vue&type=script&lang=js"
export * from "./videoRoom.vue?vue&type=script&lang=js"
import style0 from "./videoRoom.vue?vue&type=style&index=0&id=0da39dee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da39dee",
  null
  
)

export default component.exports